import { Box, Stack } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';
import { isTouchEnabled } from '../../../../../../../Theme';
import useWidth from '../../../../../../../components/Hooks/useWidth';
import useProductDetailsStore from '../../../../../../../stores/ProductDetails/productDetails.store';
import useTeceoStyles from '../../../../../../../useTeceoStyles';
import ConnectAccountModal from '../../../../../../login/ConnectAccountModal';
import OrderProductPriceV2 from '../../../../../../orders/products/product/components/OrderProductPriceV2';
import OrderProductGridContainer from '../../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/components/OrderProductGridContainer';
import useOrderProductGridStyles from '../../../../../../orders/styles/useOrderProductGrid.styles';
import ProductDetailsAddOrderButtonV2 from '../../../../ProductDetailsAddOrderButtonV2';
import { getItemHeight } from '../../../../utils/productDetailsList.components';
import CombinationItemImage from '../../../KitDetailsList/components/CombinationItemImage';
import ProductDetailsCombinationColorAndTags from '../../../ProductDetailsCombinationColorAndTags/ProductDetailsCombinationColorAndTags';
import { CombinationLineProps } from '../../types/combinationLine.types';
import { getCombinationWithImageLineHeight } from '../../utils/combinationLine.utils';
import CombinationMassActionCheckbox from '../CombinationMassActionCheckbox/CombinationMassActionCheckbox';
import CombinationLineUnavailableGrid from './CombinationLineUnavailableGrid';
import { useCombinationLineStyles } from './styles/combinationLineStyles.styles';

const CombinationLineMobile = ({
  imageUrl,
  gridLength,
  isLoggedin,
  combinationTestId,
  closeLoginModal,
  massActionProps,
  showProductImage,
  isLoginModalOpen,
  hideCombinationPrice,
  orderProductPriceProps,
  orderProductGridContainerProps,
  productDetailsAddOrderButtonV2Props,
  productDetailsCombinationColorAndTagsProps,
}: CombinationLineProps) => {
  const { isFinishedOrder, relatedProductsFilterState } = useProductDetailsStore(
    useShallow((state) => ({
      isFinishedOrder: state.productGridParams.isFinishedOrder,
      relatedProductsFilterState: state.relatedProductsFilterState,
    })),
  );
  const { mobileWidth } = useWidth();
  const { classes } = useOrderProductGridStyles({ hasTouchGrid: isTouchEnabled });
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes: itemClasses, cx } = useCombinationLineStyles({
    gridScrollerClassName: teceoClasses.hideScrollbar,
    height: relatedProductsFilterState
      ? getCombinationWithImageLineHeight(mobileWidth)
      : getItemHeight(mobileWidth),
  });

  return (
    <Stack
      justifyContent="center"
      gap={1.5}
      test-id={combinationTestId}
      className={cx({
        [classes.root]: true,
        [itemClasses.root]: true,
        [itemClasses.combinationWithImagePadding]: relatedProductsFilterState,
        [itemClasses.combinationWithoutImagePadding]: !relatedProductsFilterState,
        [itemClasses.isSelected]: massActionProps?.isSelected,
      })}
    >
      <Stack direction="row" alignItems="center" flexWrap="nowrap" gap={2}>
        <CombinationMassActionCheckbox massActionProps={massActionProps} />

        {showProductImage && <CombinationItemImage imageUrl={imageUrl} />}

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <ProductDetailsCombinationColorAndTags
            {...productDetailsCombinationColorAndTagsProps}
            selloutSummary={orderProductGridContainerProps.selloutSummary}
          />
        </Box>

        {!hideCombinationPrice && (
          <Box sx={{ flexShrink: 0 }}>
            <OrderProductPriceV2 {...orderProductPriceProps} />
          </Box>
        )}
      </Stack>

      <CombinationLineUnavailableGrid gridLength={gridLength} />

      <OrderProductGridContainer
        {...orderProductGridContainerProps}
        ExtraButton={
          isFinishedOrder || !productDetailsAddOrderButtonV2Props ? null : (
            <ProductDetailsAddOrderButtonV2 {...productDetailsAddOrderButtonV2Props} />
          )
        }
      />

      {!isLoggedin && <ConnectAccountModal open={isLoginModalOpen} onClose={closeLoginModal} />}
    </Stack>
  );
};

export default CombinationLineMobile;
